import React, { useState, useEffect } from 'react';
import { Select, Spin, message} from 'antd';
import axiosInstance from './axiosInstance';
import {useDeepCompareMemo} from './Utils'

const { Option } = Select;

function CustomSelect({ item, items, scalar, url, postData, onItemChange, onChange, value, ...props}) {
	const nullItem = {id:null,text:''}
	const [_items, setItems] = useState(items? [nullItem,...items]:[nullItem]);
	const [_fetching, setFetching] = useState(false);
	const memoizedPostData = useDeepCompareMemo(postData)

	async function fetchItems(search) {
		if( url ) {
			setFetching(true);
			try {
				const response = await axiosInstance.post(url, { search, ...postData});
				//if('searchbatch' in url)console.log(response.data.items)
				setItems([nullItem,...response.data.items]);
			} catch (error) {
				message.error('Failed to load options');
			} finally {
				setFetching(false);
			}
		} else if(items){
			const a = search ? items.filter(e => e.text.toLowerCase().includes(search.toLowerCase())) : items	
			setItems(a);	
		}
	};

	useEffect(() => { fetchItems() }, [memoizedPostData,items]);

	function handleSearch(search) {	
		fetchItems(search);
	};

	function handleChange(value) {
		console.log('select change',value)
		let v = mapoutvalue(value)
		console.log('maped',v)
		let it = typeof v === 'object'? v : _items.find(e => e.id === v);
		it = scalar && typeof(it)=== 'object'? it.id : it	 
		
		//const it = scalar? value : _items.find(e => e.id === value); 	
		
		//if(onItemChange) onItemChange(it)
		//if(onChange) onChange(value,it)
		if(onChange) {
			console.log('select send',it)
			onChange(it)
		}
		//fetchItems(); 
	};
	//console.log('called customeselect',postData?.entity)
	function mapoutvalue(value){
		return typeof value === 'object' ? {id: value.value,text: value.label} : value
	}
	function mapinvalue(value){	
		return typeof value === 'object'? {key: value?.id, label: value?.text} : value
	};

	return (
	<Select
		showSearch
		labelInValue
		value={mapinvalue(value)}
		placeholder="Select an option"
		notFoundContent={_fetching ? <Spin size="small" /> : null}
		//filterOption={(input, option) => option.value.toLowerCase().includes(input.toLowerCase()) } 
		filterOption={url?false : (input, option) => option.value.toLowerCase().includes(input.toLowerCase())}
		onSearch={url?handleSearch:false}
		onChange={handleChange}
		style={{ width: '100%'}}
		{...props}	
	>
		{_items.map((e,i) => ( <Option key={e.id} value={e.id}>{e.text}</Option>))}
	</Select>
  );
};

export default CustomSelect;
